import React, { useMemo } from 'react';
import { useQuery } from '@apollo/client';
import { ModalContainer, ModalContent, ModalFooter, ModalHeader } from 'components/@common/Modal';
import GET_USER_INFORMATION_QUERY from 'graph/user/get-user-information';
import useParseActionRouteParams from 'hooks/route-action/use-parse-action-route-params';
import useUiStore from 'store/ui';
import { User } from 'types/schema-generated-types';
import { getAssignedProducts } from 'utilities/product-utils';
import UserInformationHeader from './components/UserInformationHeader';
import UserInformationBody from './components/UserInformationBody';

const UserDetailsModal: React.FC = () => {
  const [, { closeModal }] = useUiStore();
  const { userId } = useParseActionRouteParams();
  const { data, loading } = useQuery(GET_USER_INFORMATION_QUERY, {
    variables: { where: { id: Number(userId) } }
  });

  const user = data?.user as User;

  const activeProducts = useMemo(
    () => (user?.licenseUsage ? getAssignedProducts(user.licenseUsage) : []),
    [user]
  );

  return (
    <ModalContainer
      Header={<ModalHeader title="User Information" />}
      Footer={<ModalFooter onCancel={closeModal} />}
    >
      <ModalContent>
        {!loading && (
          <>
            <UserInformationHeader
              userId={user?.id}
              avatarUrl={user?.avatarUrl}
              firstName={user?.firstName}
              lastName={user?.lastName}
              userStatus={user?.status}
            />
            <UserInformationBody
              pin={user?.pin || ''}
              email={user?.username || ''}
              organizationAssociations={user?.organizationAssociations || []}
              lastActive={user?.dateUpdated}
              licensedProducts={activeProducts}
              classroomEnrollments={user?.classroomEnrollments || []}
            />
          </>
        )}
      </ModalContent>
    </ModalContainer>
  );
};

export default UserDetailsModal;
